module.exports = __webpack_public_path__ + "static/media/patentIcon.fca365c4.png";